import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import AlertaContext from "../../context/alertas/alertaContext";
import AuthContext from "../../context/autenticacion/authContext";

const Login = (props) => {
  // extraer los valores del context
  const alertaContext = useContext(AlertaContext);
  const { alerta, mostrarAlerta } = alertaContext;

  const authContext = useContext(AuthContext);
  const { mensaje, accesos, autenticado, iniciarSesion } = authContext;

  useEffect(() => {
    if (autenticado) {
      props.history.push(accesos ? accesos[0].link : "/resultados");
    }

    if (mensaje) {
      mostrarAlerta(mensaje.msg, mensaje.categoria);
    }
    // eslint-disable-next-line
  }, [mensaje, autenticado, props.history]);

  // State para iniciar sesión
  const [usuario, guardarUsuario] = useState({
    email: "",
    password: "",
  });

  // Extraer de usuario
  const { email, password } = usuario;

  const onChange = (e) => {
    guardarUsuario({
      ...usuario,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // Validar que no haya campos vacíos
    if (email === "" || password === "") {
      mostrarAlerta("Todos los campos son obligatorios", "alert-danger");
      return;
    }

    // Pasarlo al reducer
    iniciarSesion({ email, password });
  };

  return (
    <div className="container">
      <div className="row">
        <h1 className="my20 col-md-8 col-md-offset-3">
          Laboratorio No. 1 en investigaciones médicas
        </h1>
        <div className="col-md-4 col-md-offset-4">
          {alerta ? (
            <div
              className={`alert ${alerta.categoria} alert-dismissible fade in`}
            >
              {" "}
              {alerta.msg}{" "}
            </div>
          ) : null}
          <div className="card">
            <form className="form-signin" onSubmit={onSubmit}>
              <div className="text-center">
                <img
                  className="mb-4 img-fluid"
                  src="img/logo-limed.png"
                  alt="limed"
                  height="60"
                />
              </div>
              <h1 className="h3 mb-3 font-weight-normal text-center">
                Consulta de resultados
              </h1>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control mb20"
                placeholder="Usuario"
                value={email}
                onChange={onChange}
              />

              <input
                type="password"
                id="password"
                name="password"
                className="form-control mb20"
                placeholder="Contraseña"
                value={password}
                onChange={onChange}
              />
              <div className="text-center">
                <Link to={"/password"}>Olvidé mi contraseña</Link>
              </div>
              <button
                className="btn btn-lg btn-primary btn-block"
                type="submit"
              >
                <i className="bi bi-box-arrow-in-right"></i>
              </button>
            </form>
          </div>
          <p>
            Si no tienes una cuenta <Link to={"/registro"}>Regístrate</Link>{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
